import React, { lazy } from 'react';

// Lazy-loaded page components (code-split per page)
const AllCorrespondentsTransactions = lazy(() => import('./pages/reports/AllCorrespondentsTransactions'));
const AnalystRemittanceReportPage = lazy(() =>
  import('./pages/remittance/RemittanceReportPage').then((m) => ({ default: m.AnalystRemittanceReportPage }))
);
const ConciliationComission = lazy(() => import('./pages/reports/ConciliationComissionPage'));
const CorrespondentsPage = lazy(() => import('./pages/reports/CorrespondentsPage'));
const CorrespondentsReports = lazy(() => import('./pages/reports/CorrespondentsReportsPage'));
const CorrespondentSubsidiariesPage = lazy(() => import('./pages/reports/CorrespondentSubsidiariesPage'));
const CorrespondentSubsidiariesReportPage = lazy(() => import('./pages/reports/CorrespondentSubsidiariesReportPage'));
const SubsidiariesReportPage = lazy(() => import('./pages/reports/SubsidiariesReportPage'));
const UnlockCrspUsers = lazy(() => import('./pages/userManagement/UnlockCrspUsers'));
const CorrespondentUsers = lazy(() => import('./pages/userManagement/CorrespondentUsers'));
const UsersReportBank = lazy(() => import('./pages/reports/UsersReportBank'));

/**
 * Analyst feature permission-to-component map.
 * Keys match the `name` field from backend permissions.
 */
export const analystPages = (displayName: string): Record<string, React.ReactNode> => ({
  crpdntTransactionsReport: <AllCorrespondentsTransactions title={displayName} />,
  remittancesMonthlyReport: <AnalystRemittanceReportPage />,
  paymentComissions: <ConciliationComission />,
  crpdntManagement: <CorrespondentsPage />,
  crpndntReport: <CorrespondentsReports />,
  crpdntSubsidiariesList: <CorrespondentSubsidiariesPage />,
  crspSubsidiaryManagement: <CorrespondentSubsidiariesPage />,
  crpdntSubsidiaryReport: <CorrespondentSubsidiariesReportPage />,
  subsidiaryReport: <SubsidiariesReportPage />,
  unlockCrspUsers: <UnlockCrspUsers title={displayName} />,
  crspUsers: <CorrespondentUsers title={displayName} />,
  bankCrpdntUserReport: <UsersReportBank />,
});
